import React from 'react';

function Privacy() {
  return (
    <div>
      <section className="page-hero">
        <div className="page-hero-inner">
          <p className="eyebrow">Legal</p>
          <h1>Privacy Policy</h1>
          <p>Last updated: June 2026</p>
        </div>
      </section>

      <section className="legal-page">
        <div className="legal-inner">
          <p>[Placeholder text — replace this with your actual privacy policy.]</p>

          <h3>1. Information We Collect</h3>
          <p>[Placeholder text describing what information is collected, e.g. name, email, phone number, via the registration form.]</p>

          <h3>2. How We Use Your Information</h3>
          <p>[Placeholder text describing how the information is used.]</p>

          <h3>3. Data Sharing</h3>
          <p>[Placeholder text describing whether data is shared with third parties.]</p>

          <h3>4. Data Security</h3>
          <p>[Placeholder text describing how data is protected.]</p>

          <h3>5. Your Rights</h3>
          <p>[Placeholder text describing user rights regarding their data.]</p>

          <h3>6. Contact Us</h3>
          <p>If you have any questions about this Privacy Policy, you can contact us at childrenimpactdev@gmail.com.</p>
        </div>
      </section>
    </div>
  );
}

export default Privacy;